// for mobile device detection

export const COARSE_POINTER = '(pointer: coarse)';

export const matchIsMobileDevice = () => window.matchMedia(COARSE_POINTER).matches;

// for generating media queries into the styles

export const Breakpoints = {
    xxs: '480px',
    xs: '600px',
    s: '960px',
    m: '1280px',
    l: '1440px',
    xl: '1600px',
    xxl: '1920px',
    xxxl: '2560px',
};

export type Breakpoint = keyof typeof Breakpoints;
export const BREAKPOINT_ORDER = (Object.keys(Breakpoints) as Breakpoint[]).sort(
    (a, b) => parseInt(Breakpoints[a], 10) - parseInt(Breakpoints[b], 10)
);

export const MQ = (breakpoint: string) => `@media screen and (min-width: ${breakpoint})`;
export const MQHeight = (breakpoint: string) => `@media screen and (min-height: ${breakpoint})`;

// for touch and no touch device detection

export const MQ_TOUCH = `@media ${COARSE_POINTER}`;
export const MQ_NOT_TOUCH = `@media not all and ${COARSE_POINTER}`;

// for media query detection

export const MOBILE_MQ = `(max-width: ${Breakpoints.s})`;
export const MOBILE_LANDSCAPE_MQ = `(max-width: ${Breakpoints.s}) and (orientation: landscape)`;
export const TABLET_MQ = `(min-width: ${Breakpoints.s})`;
export const DESKTOP_MQ = `(min-width: ${Breakpoints.m})`;

export const isMQMobile = () => window.matchMedia(MOBILE_MQ).matches;

export const isMQMobileLandscape = () => window.matchMedia(MOBILE_LANDSCAPE_MQ).matches;

export const isMQTablet = () => window.matchMedia(TABLET_MQ).matches;

export const isMQDesktop = () => window.matchMedia(DESKTOP_MQ).matches;

export const touchDevicePortrait = `@media ${COARSE_POINTER} and (orientation:portrait)`;
export const touchDeviceLandscape = `@media ${COARSE_POINTER} and (orientation:landscape)`;

export const isOrientationPortrait = () => window.matchMedia('(pointer: coarse) and (orientation:portrait)').matches;

export const isOrientationLandscape = () => window.matchMedia('(pointer: coarse) and (orientation:landscape)').matches;

// for reduced motion preference

export const REDUCED_MOTION_MQ = '(prefers-reduced-motion: reduce)';
export const MQ_REDUCED_MOTION = `@media ${REDUCED_MOTION_MQ}`;

export const matchPrefersReducedMotion = () => window.matchMedia(REDUCED_MOTION_MQ).matches;
